import { type Infer, literal, object, string } from "superstruct";

export const BodyBlockSchema = object({
    id: string(),
    type: literal("body"),
    html: string(),
});

export type BodyBlock = Infer<typeof BodyBlockSchema>;
